import FormSubmitToggle from 'utils/form_submit_toggle';
import validator from 'utils/validator';
import zaraz from 'utils/trackers/zaraz';

validator.init();
new FormSubmitToggle('#login_form');

(() => {
  'use strict';
  const container = $('#login_form').parents('.q-page');

  if (container.hasClass('q-checkout-auth-page')) {
    $('#login_form').on('submit', e => {
      e.stopPropagation();

      zaraz.ecommerce('Checkout Step Viewed', {
        step: 2
      });
    });
  }
})();
